import {ONE_DAY_MS} from '@/shared/consts/time';

import {CAMPAIGN} from './serve/consts';
import {get, remove, set} from './serve/localStorage';

const CAMPAIGN_EXPIRATION_MS = 30 * ONE_DAY_MS;

type Campaign = {
  value: string;
  createdAt: number;
};

export function validCampaign(createdAt: number): boolean {
  return Date.now() - createdAt < CAMPAIGN_EXPIRATION_MS;
}

export function setCampaign(value: string) {
  set<Campaign>(CAMPAIGN, {
    value,
    createdAt: Date.now(),
  });
}

export function getCampaign() {
  return get<Campaign>(CAMPAIGN);
}

export function consumeCampaign() {
  const campaign = get<Campaign>(CAMPAIGN);

  remove(CAMPAIGN);

  return campaign;
}

export function getUtmParam(name: string) {
  const campaign = getCampaign();

  if (!campaign) {
    return null;
  }

  if (!validCampaign(campaign.createdAt)) {
    return null;
  }

  const params = new URLSearchParams(campaign.value);
  return params.get(name);
}
